import logoWhite from "../assets/logos/nowquantum-white.png?w=400&format=webp";
import { Link } from "react-router-dom";
import { usePageTranslations } from "../i18n/context";
import { openCookiePreferences } from "../lib/cookieConsent";

export default function Footer() {
  const { t } = usePageTranslations("common");

  const columns = [
    {
      title: t("footer.company"),
      links: [
        { label: t("footer.about"), href: "/about" },
        { label: t("footer.contact"), href: "/contact" },
      ],
    },
  ];

  return (
    <footer className="bg-[#111111] border-t border-[var(--color-border)]" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        {/* Top: Logo + Tagline + Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/">
              <img
                src={logoWhite}
                alt="NowQuantum"
                className="h-7 w-auto mb-4"
                width="140"
                height="43"
              />
            </Link>
            <p
              className="text-white/75 text-sm leading-relaxed font-['Geist_Sans',sans-serif]"
            >
              {t("footer.tagline")}
            </p>
            <p className="text-white/50 text-xs mt-2 font-['Geist_Sans',sans-serif]">
              {t("footer.boilerplate")}
            </p>
            <p className="text-white/75 text-xs mt-3 font-['Geist_Sans',sans-serif]">
              {t("footer.location")}
            </p>
          </div>

          {/* Link Columns */}
          {columns.map((col) => (
            <div key={col.title}>
              <h3
                className="text-[10px] uppercase tracking-[0.15em] text-white/80 font-semibold mb-4"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                {col.title}
              </h3>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="footer-link text-sm text-white/70 hover:text-white/90 transition-colors duration-150 font-['Geist_Sans',sans-serif]"
                    >
                      {link.label.endsWith("Q") ? <>{link.label.slice(0, -1)}<span style={{ color: "var(--color-brand-primary)" }}>Q</span></> : link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div className="border-t border-[var(--color-border)] pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-white/80 font-['Geist_Sans',sans-serif]">
            &copy; {new Date().getFullYear()} {t("footer.copyright")}
          </p>
          <div className="flex flex-wrap gap-x-4 gap-y-1 items-center">
            <Link
              to="/privacy"
              className="text-xs text-white/80 hover:text-white/90 transition-colors font-['Geist_Sans',sans-serif]"
            >
              {t("footer.privacy")}
            </Link>
            <span className="text-xs text-white/20">·</span>
            <Link
              to="/terms"
              className="text-xs text-white/80 hover:text-white/90 transition-colors font-['Geist_Sans',sans-serif]"
            >
              {t("footer.termsOfService")}
            </Link>
            <span className="text-xs text-white/20">·</span>
            <Link
              to="/cookies"
              className="text-xs text-white/80 hover:text-white/90 transition-colors font-['Geist_Sans',sans-serif]"
            >
              {t("footer.cookiePolicy")}
            </Link>
            <span className="text-xs text-white/20">·</span>
            <button
              type="button"
              onClick={openCookiePreferences}
              className="text-xs text-white/80 hover:text-white/90 transition-colors font-['Geist_Sans',sans-serif] cursor-pointer"
            >
              {t("footer.cookiePreferences")}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
